<template>
  <div class="bg-light-gray px-4 mb-2">
    <div class="row">
      <div class="col-12 mb-3 ">
        <icon-view
          :has-border="false"
          icon="fas fa-comment text-orange"
          icon-size="17px"
          title="Añadir Bitácora"
          variant="custom-icon-view"
          icon-background="white"
        />
      </div>
    </div>
    <validation-observer ref="formModalObserver" novalidate tag="form">
      <div class="row">
        <div class="col-12 col-md-4" v-if="isReferral">
          <validation-provider
            v-slot="{ errors }"
            mode="eager"
            rules="required"
          >
            <custom-drop-down
              :options="binnacleClassifications"
              label="Clasificación:"
              fieldkey="id"
              fieldname="name"
              placeholder="Seleccione una clasificación"
              class="w-100 mb-4 bold-label"
              custom-error-msg="Favor seleccione una clasificación"
              :error="errors[0]"
              v-model="model.classificationId"
            />
          </validation-provider>
        </div>
        <div class="col-12 col-md-4">
          <validation-provider
            v-slot="{ errors }"
            mode="eager"
            rules="required"
          >
            <custom-input
              v-model="model.documentName"
              custom-error-msg="El asunto es requerido"
              :error="errors[0]"
              label="Asunto:"
              type="text"
            />
          </validation-provider>
        </div>
        <div class="col-12 col-md-4 mb-2">
          <div class="data-label mb-2">
            Archivo:
          </div>
          <validation-provider mode="eager">
            <custom-file-input
              ref="billingAdjustmentObjected"
              v-model="model.attachment"
              :accept="'.pdf'"
              :attachment-id="model.attachmentId"
              display-style="normal"
              :on-download="downloadFile"
            />
          </validation-provider>
        </div>
        <div class="col-12">
          <validation-provider v-slot="{ errors }" rules="required">
            <div class="color-black font-14 my-1">
              Comentario de Bitácora:
            </div>
            <custom-text-area
              id="txtComment"
              v-model="model.comment"
              :count-classes="['d-block', 'small-counter', 'text-right']"
              custom-error-msg="Favor escriba un comentario"
              :error="errors[0]"
              :maxlength="3000"
              placeholder="Escribe un comentario"
              show-char-count
            />
          </validation-provider>
        </div>
      </div>
    </validation-observer>
    <div class="d-flex justify-content-end align-items-center mt-4">
      <action-button
        id="btnCancel"
        i="fas fa-times-circle"
        text="Cancelar"
        variant="outline-danger mr-3 px-3"
        @click="cancel()"
      />
      <action-button
        id="btnSave"
        i="fas fa-save"
        text="Guardar"
        variant="success px-3"
        @click="handlerAddBinnacle"
      />
    </div>
  </div>
</template>

<script>
import CustomInput from 'CustomInput';
import CustomFileInput from 'CustomFileInput';
import CustomTextArea from '@quisit/custom-text-area';
import ActionButton from 'ActionButton';
import CustomDropDown from 'custom-drop-down';
import IconView from 'icon-view';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import referralAndEquipmentsservice from '@/services/api/referralsandequipments.api';

export default {
  name: 'AddBinnacle',
  components: {
    CustomInput,
    CustomFileInput,
    CustomTextArea,
    ActionButton,
    IconView,
    CustomDropDown,
  },
  mixins: [alertMixin],
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    isReferral: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      binnacleClassifications: [],
    };
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  mounted() {
    this.getBinnacleClassifications();
  },
  methods: {
    downloadFile() {},
    cancel() {
      this.$refs.formModalObserver.reset();
      this.model = {
        attachment: null,
        attachmentId: null,
        comment: null,
        documentName: null,
      };
      this.$emit('cancel');
    },
    async handlerAddBinnacle() {
      const isvalid = await this.$refs.formModalObserver.validate();
      if (!isvalid) {
        this.ShowToast(
          'Alerta',
          'Por favor completa los campos requeridos.',
          'error'
        );
        return;
      }
      this.$emit('save');
    },
    async getBinnacleClassifications() {
      const {
        data,
      } = await referralAndEquipmentsservice.getCommentClassifications();
      this.binnacleClassifications = data;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .dot {
  padding: 19px !important;
}
</style>
